import * as React from 'react';
import {AuthWrapper, CreateFormFlex, CreateFormWrapper} from "./share/auth_share_components";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import AuthApplyClientLafoolRegisterSide from "./apply_client_lafool_register/auth_apply_client_lafool_register_side";
import AuthApplyClientLafoolRegisterForm from "./apply_client_lafool_register/auth_apply_client_lafool_register_form";


interface IProps {
    isLafoolMedical: boolean;
    handleApplyClientByLafool: (values: any) => void;
    handleApplyClientByLafoolMedical: (value: any) => void;
}

const AuthApplyClientLafoolRegisterComponent: React.FC<IProps> = (props) => {
    const {
        isLafoolMedical,
        handleApplyClientByLafool,
        handleApplyClientByLafoolMedical
    } = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <CreateFormWrapper>
                    <CreateFormFlex>
                        <AuthApplyClientLafoolRegisterSide isLafoolMedical={isLafoolMedical}/>
                        <AuthApplyClientLafoolRegisterForm
                            onSubmit={isLafoolMedical ? handleApplyClientByLafoolMedical : handleApplyClientByLafool}
                        />
                    </CreateFormFlex>
                    <ParagraphSup>© Libera Inc.</ParagraphSup>
                </CreateFormWrapper>
            </AuthWrapper>
        </React.Fragment>
    )

};

export default AuthApplyClientLafoolRegisterComponent;




// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_apply_client_lafool_register.tsx